import { createContext, useContext, useState } from "react";

interface Context {
  idManifestacao: string | null;
  setIdManifestacao: (idManifestacao: string | null) => void;
}

const VerManifestacaoProviderContext = createContext<Context>({
  idManifestacao: null,
  setIdManifestacao: () => null
});

const Provider: React.FC = ({ children }) => {
  const [idManifestacao, setIdManifestacao] = useState<string | null>(null);

  return (
    <VerManifestacaoProviderContext.Provider
      value={{
        idManifestacao,
        setIdManifestacao
      }}
    >
      {children}
    </VerManifestacaoProviderContext.Provider>
  );
};

export const useVerManifestacao = (): Context =>
  useContext(VerManifestacaoProviderContext);

export default Provider;
